import React from 'react'

const OfferButton = ({ isDisabled, onClick, ...props }) => (
  <div onClick={() => onClick()}>
    <span>Create New Offer</span>
  </div>
)

export default OfferButton
